import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';

interface IPendingReplace {
  agreementCode?: string;
  resolve: (isConfirmed: boolean) => void;
}

/**
 * The Overwrite toggle's replace-the-pick prompt, as an awaitable call.
 */
export const useReplaceSelectedSpaConfirmation = () => {
  const [pendingReplace, setPendingReplace] = useState<IPendingReplace | null>(null);

  const { t } = useTranslation();

  const confirmReplaceSelectedSpa = useCallback(
    (agreementCode?: string) =>
      new Promise<boolean>((resolve) => setPendingReplace({ agreementCode, resolve })),
    []
  );

  const settle = (isConfirmed: boolean) => {
    pendingReplace?.resolve(isConfirmed);
    setPendingReplace(null);
  };

  const replaceSelectedSpaConfirmation = (
    <Confirmation
      isOpen={!!pendingReplace}
      title={t('titleReplaceSelectedSpa')}
      message={t('messageConfirmReplaceSelectedSpa', {
        agreementCode: pendingReplace?.agreementCode,
      })}
      onConfirm={() => settle(true)}
      onCancel={() => settle(false)}
    />
  );

  return { confirmReplaceSelectedSpa, replaceSelectedSpaConfirmation };
};
